// language=GraphQL
export const ALL_AGE_GROUP_CAPACITIES_QUERY = `query Query($withAgeGroup: Boolean = false) {
  ageGroupCapacities: accommodationAgeGroupCapacities {
    id
    ageGroup @include(if: $withAgeGroup) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    minCapacity
    maxCapacity
  }
}`

// language=GraphQL
export const SINGLE_AGE_GROUP_CAPACITY_QUERY = `query Query($id: ID!, $withAgeGroup: Boolean = false) {
  ageGroupCapacity: accommodationAgeGroupCapacity(id: $id) {
    id
    ageGroup @include(if: $withAgeGroup) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    minCapacity
    maxCapacity
  }
}`

// language=GraphQL
export const CREATE_AGE_GROUP_CAPACITY_MUTATION = `
  mutation Mutation($input: CreateAccommodationAgeGroupCapacityInput, $withAgeGroup: Boolean = false) {
    ageGroupCapacity: createAccommodationAgeGroupCapacity(input: $input) {
      id
      ageGroup @include(if: $withAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      minCapacity
      maxCapacity
    }
  }`

// language=GraphQL
export const UPDATE_AGE_GROUP_CAPACITY_MUTATION = `
  mutation Mutation($input: UpdateAccommodationAgeGroupCapacityInput, $withAgeGroup: Boolean = false) {
    ageGroupCapacity: updateAccommodationAgeGroupCapacity(input: $input) {
      id
      ageGroup @include(if: $withAgeGroup) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      minCapacity
      maxCapacity
    }
  }`

// language=GraphQL
export const DELETE_AGE_GROUP_CAPACITY_MUTATION = `
  mutation Mutation($input: DeleteAccommodationAgeGroupCapacityInput) {
    deleteAccommodationAgeGroupCapacity(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_AGE_GROUP_CAPACITY_MUTATION = `
  mutation Mutation($input: DeleteAccommodationAgeGroupCapacityInput) {
    forceDeleteAccommodationAgeGroupCapacity(input: $input) {
      success
    }
  }`
// language=GraphQL
export const AGE_GROUP_CAPACITIES_DEPENDENTS_QUERY = `query Query($id: ID!, $withAccommodationCapacitySettings: Boolean = false) {
  groupedDependents: accommodationAgeGroupCapacityDependents(id: $id) {
    accommodationCapacitySettings @include(if: $withAccommodationCapacitySettings) {
      id
      totalCapacity
      rangesAllowed
      partialOccupancyAllowed
    }
  }
}`
